import { createActions } from 'redux-actions'

export const INIT_CATEGORY_INFO = "INIT_CATEGORY_INFO";

export const REQUEST_CATEGORY_START = "REQUEST_CATEGORY_START";
export const REQUEST_CATEGORY_SUCCESS = "REQUEST_CATEGORY_SUCCESS";
export const REQUEST_CATEGORY_FAIL = "REQUEST_CATEGORY_FAIL";

export const {

  initCategoryInfo,
  requestCategoryStart,
  requestCategorySuccess,
  requestCategoryFail,

} = createActions({

  [INIT_CATEGORY_INFO]: (req) => ({ req }),

  [REQUEST_CATEGORY_START]: (req) => ({ ...req }),
  [REQUEST_CATEGORY_SUCCESS]: (res) => ({ res }),
  [REQUEST_CATEGORY_FAIL]: (res) => ({ res }),

})


